class BrandCallStatus {
  codResult: string = ""

  descResult: string = ""
}

class BrandDetail {
  codMarca: string = ""

  descMarca: string = ""

  desMarca?: string = ""

  codMarcaApeseg: string = ""

  codMarcaApeSeg?: string = ""
}

class Brands {
  resultado: BrandCallStatus | any = new BrandCallStatus()
  marcas: Array<BrandDetail> = []
}

class BrandResponse {
  datos: Brands = new Brands()
}

export { Brands, BrandDetail, BrandCallStatus, BrandResponse }
